const actions = {
    SEARCH_READ_TRANSACTIONS_REQUEST: 'SEARCH_READ_TRANSACTIONS_REQUEST',
    SEARCH_READ_TRANSACTIONS_SUCCESS: 'SEARCH_READ_TRANSACTIONS_SUCCESS',
    SEARCH_READ_TRANSACTIONS_ERROR: 'SEARCH_READ_TRANSACTIONS_ERROR',

    SEARCH_CACHE_SEARCH_TERM: 'SEARCH_CACHE_SEARCH_TERM',

    readTransactions: request => ({
        type: actions.SEARCH_READ_TRANSACTIONS_REQUEST,
        request,
    }),
    cacheSearchTerm: searchTerm => ({
        type: actions.SEARCH_CACHE_SEARCH_TERM,
        searchTerm,
    }),
};
export default actions;
